'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feiseanna = require('../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _session = require('../../../session');

var _session2 = _interopRequireDefault(_session);

var _timezonesJson = require('../../../../node_modules/timezones-json');

var _timezonesJson2 = _interopRequireDefault(_timezonesJson);

var _currencies = require('../../../common/utils/currencies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = require('moment-timezone');

exports.default = angular.module('ifeis.routes.feiseanna.create', ['ui.router', 'ngMaterial', 'ifeis.feiseanna', 'ifeis.session']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.create', {
    url: '/create/:uuid',
    template: require('./tpl.html'),
    controller: 'CreateFeisController',
    resolve: {
      invite: function invite(fSession, fFeisService, $stateParams, $q) {
        var userId = void 0;
        return fSession.user().then(function (user) {
          userId = user.id;
          return fFeisService.invite($stateParams.uuid);
        }).then(function (invite) {
          if (invite.used === 1 || invite.invalid === 1 || invite.person.id !== userId) {
            return $q.reject();
          } else {
            return invite;
          }
        });
      }
    }
  });
}).run(function ($state, $rootScope) {
  $rootScope.$on('$stateChangeError', function (event, toState) {
    if (toState.name === 'feiseanna.create') {
      $state.go('check-auth', {}, { location: false });
    }
  });
}).controller('CreateFeisController', function ($scope, fFeisService, invite, $state) {
  $scope.invite = invite;
  $scope.tz = _timezonesJson2.default;

  $scope.currencies = (0, _currencies.getCurrencies)();

  // Setup a new Feis object
  $scope.feis = {};
  // Guess new Feis timezone based on user browser data
  $scope.feis.tz = moment.tz.guess();

  fFeisService.templates().then(function (result) {
    $scope.templates = result;
  });

  $scope.submit = function (f) {
    var feis = angular.copy(f);
    feis.id = invite.id;

    fFeisService.create(feis).then(function (createdFeis) {
      $state.go('feiseanna.one.admin.manager', { id: createdFeis.id, slug: createdFeis.slug });
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/create/index.js
// module id = 218
// module chunks = 0